import Highlighter from "react-highlight-words";
import { ResourceType } from "../../../../interfaces/general";
import { isFolder, setIconFile } from "../../../../scripts/helpers";
import Folder from "../../../../assets/images/fileManager/Folder.svg";

type SearchResultBoxProps = {
    count: number;
    title: string;
    contentSearchResults: any[];
    onItemClick: (result: ResourceType) => void;
    onShowAllClick: () => void;
    searchValue: string;
    maxLength: number;
};

const SearchResultBox = ({ count, title, contentSearchResults, onItemClick, onShowAllClick, searchValue, maxLength }: SearchResultBoxProps) => {
    if (count)
        return (
            <div className="sm:bg-white pt-2 px-4">
                <div className="flex items-center justify-between pb-3 mb-1 border-b border-[#D9DBE9]">
                    <div className="flex items-center gap-1">
                        <p className="text-[#14142A] font-medium text-sm">نتایج جستجو در "{title}"</p>
                        <span className="text-sm font-normal text-secondary-500">({count} فایل)</span>
                    </div>

                    <button
                        onClick={(e) => {
                            e.stopPropagation();
                            onShowAllClick();
                        }}
                        className="text-[#2991FF] font-medium text-sm"
                    >
                        مشاهده همه
                    </button>
                </div>
                {contentSearchResults.map((result, index) => {
                    return (
                        index < maxLength && (
                            <div
                                className="flex gap-2 items-center cursor-pointer !max-w-max py-2.5 text-secondary-500 text-[12px] font-medium"
                                onClick={(e) => {
                                    e.stopPropagation();
                                    onItemClick(result);
                                }}
                            >
                                <img className="w-[22px] h-[22px]" src={isFolder(result) ? Folder : setIconFile(result.name)} alt="icon" />
                                <Highlighter
                                    className="whitespace-nowrap overflow-hidden text-ellipsis"
                                    searchWords={[searchValue]}
                                    autoEscape={true}
                                    textToHighlight={result.name}
                                    highlightStyle={{ color: "black", backgroundColor: "transparent", fontWeight: "500px", fontSize: "14px" }}
                                />
                            </div>
                        )
                    );
                })}
            </div>
        );
    else return null;
};

export default SearchResultBox;
